<template>
	<div class="simple_gallary_screen" id="gallery">
		<div class="simple_gallary_carousel_box">
			<carousel v-if="screenWidth < 520"
				:per-page="1"
				:mouse-drag="true"
				:loop="true"
				:navigationEnabled="true"
				:navigationNextLabel="`<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 40C1 31.2193 8.7463 23.6256 20 20C8.7463 16.3744 1 8.7807 1 -2.22278e-06' stroke='#A39171' style='stroke:#A39171;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>`"
				:navigationPrevLabel="`<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M20 40C20 31.2193 12.2537 23.6256 0.999999 20C12.2537 16.3744 20 8.7807 20 -2.22278e-06' stroke='#A39171' style='stroke:#A39171;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>`"
			>

				<slide :key="idx" v-for="(img, idx) in items" style="padding: 0.5em;">
					<img style="width: 95%; height: auto; object-fit: cover;" :src="img" alt="">
				</slide>
			</carousel>
			<carousel v-if="screenWidth > 520"
				:per-page="1"
				:mouse-drag="true"
				:loop="true"
				:navigationEnabled="true"
				:navigationNextLabel="`<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 40C1 31.2193 8.7463 23.6256 20 20C8.7463 16.3744 1 8.7807 1 -2.22278e-06' stroke='#A39171' style='stroke:#A39171;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>`"
				:navigationPrevLabel="`<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M20 40C20 31.2193 12.2537 23.6256 0.999999 20C12.2537 16.3744 20 8.7807 20 -2.22278e-06' stroke='#A39171' style='stroke:#A39171;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>`"
			>
				<slide :key="idx" v-for="(src, idx) in items">
					<div class="simple_gallary_carousel_item_box">
						<img style="width: 80%;" :src="src" alt="">
					</div>
				</slide>
			</carousel>
		</div>
	</div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel';

export default {
	props: {
		// items: {
		// 	type: Array,
		// 	default: [],
		// }
	},
	name: "SimpleGalleryComponent",
	components: {
		Carousel,
		Slide,
	},
	data() {
		return {
			screenScrolled: 0,
			screenWidth: 0,
			screenHeight: 0,
			items: [
				require('../assets/img/site/2.jpg'),
				require('../assets/img/site/5.jpg'),
				require('../assets/img/site/7.jpg'),
				require('../assets/img/site/3.jpg'),
				require('../assets/img/site/8.jpg'),
				require('../assets/img/site/12.jpg'),
				require('../assets/img/site/10.jpg'),
				require('../assets/img/site/18.jpg'),
				require('../assets/img/site/15.jpg'),
				require('../assets/img/site/14.jpg'),
				require('../assets/img/site/13.jpg'),
				require('../assets/img/site/16.jpg'),
				require('../assets/img/site/6.jpg'),
				require('../assets/img/site/1.jpg'),
				require('../assets/img/site/4.jpg'),
				require('../assets/img/site/11.jpg'),
				require('../assets/img/site/17.jpg'),
				require('../assets/img/site/20.jpg'),
			],
		}
	},
	mounted() {
		window.addEventListener('resize', this.handleResize)
		window.addEventListener('scroll', this.handleScroll)
		this.handleResize()
		this.handleScroll()
	},
	computed: {
		// screenScrolled() {
		// 	return window.scrollY
		// }
	},
	methods: {
		handleScroll() {
			this.screenScrolled = window.scrollY;
		},
		handleResize() {
			this.screenWidth = window.innerWidth;
			this.screenHeight = window.innerHeight;
		}
	},
}
</script>

<style>
.VueCarousel-dot, .VueCarousel-dot:active {
	background-color: transparent !important;
	border: 1px solid #A39171 !important;
	padding: 0 !important;
	margin: 0.5em;
}
.VueCarousel-dot.VueCarousel-dot--active {
	background-color: #A39171 !important;
}
.simple_gallary_carousel_box {
	width: 80%;
	margin: 0 auto;
	/*padding: 0 10%;*/
	padding: 5em 0em;
	/*display: flex;*/
	/*flex-direction: column;*/
	/*flex-wrap: nowrap;*/
	/*justify-content: center;*/
	/*align-items: center;*/
	/*align-content: center;*/
}
.simple_gallary_screen {
	padding: 0em;
	background: #F7F3EDFF;
	width: 100%;

	text-align: center;
	position: relative;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: center;
}
.simple_gallary_carousel_box img  {
	object-fit: cover;
	width: 100%;
	height: 100%;
	max-height: 500px;
	border-radius: 10px 10px 10px 10px;
}

.simple_gallary_carousel_item_box {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: center;
	align-items: flex-start;
	justify-content: center;
}
@media (max-width: 575px) {
	.simple_gallary_carousel_box {
		width: 100%;
	}
	.VueCarousel-navigation-next,
	.VueCarousel-navigation-prev {
		height: 1.4em;
		padding: 0 !important;
		margin: 0 !important;
	}
	.VueCarousel-navigation-next {
		transform: translateY(-100%) translateX(100%);
		right: 0.95em !important;
	}
	.VueCarousel-navigation-prev {
		transform: translateY(-100%) translateX(-100%);
		left: 0.95em !important;
	}
	.VueCarousel-navigation-next svg,
	.VueCarousel-navigation-prev svg {
		height: 100%;
		width: auto;

	}
}
</style>